import { createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../api";
import { apiUrlV1 } from "../../config/config";
import { gamesMiddleware } from "../../middleware/gameMiddleware";
import { unauthorizedHandler } from "../Auth/authStore";

/**
 * A failed (or empty) load is not retried sooner than this. Pages dispatch getGames from effects
 * keyed on "list empty and not loading" — after a failure that is true again at once, so without
 * this pause a 401 turned into thousands of requests a minute.
 */
const RETRY_AFTER_FAILURE_MS = 30_000;

export const getGames = createAsyncThunk(`games/list`,
  async (_, thunksApi) => {
    try {
      const responseGameV3 = await agent.get(`${apiUrlV1}/v3/organization/game/list/system-names`)

      if (responseGameV3.ok) {
        const body = await responseGameV3.json();
        const result = await gamesMiddleware(body)
        return result;
      }
      if (!responseGameV3.ok && responseGameV3.status === 401) {
        const body = await responseGameV3.json();
        thunksApi.dispatch(unauthorizedHandler({ code: body.statusCode, message: body.message, status: true }))
        throw Error("No response");
      }
      return [];
    } catch (error) {
      throw Error("No response");
    }
  },
  {
    condition: (_, { getState }) => {
      const { loading, lastFailedAt } = (getState() as { games: { loading: boolean; lastFailedAt: number | null } }).games;
      if (loading) return false;
      return !(lastFailedAt && Date.now() - lastFailedAt < RETRY_AFTER_FAILURE_MS);
    },
  },
)